import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function ChevronLeftIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 11L0.999999 6L6 1"
          stroke="#01354C"
          strokeWidth="1.99995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
